module.exports = __webpack_public_path__ + "static/img/demo-texting.4ac67f48.svg";